import axios from 'axios';
import * as types from '../mutation-types';

export default {
  state: {
    all: [],
  },
  getters: {
    getQuestions: state => state.all,
    getQuestionsForLevel: state => _level => state.all.filter(({ level }) => level <= _level),
  },
  actions: {
    getQuestions({ commit }) {
      return new Promise((resolve) => {
        axios.get('https://acl.new.pixel-kraft.de/api/questions').then(({ data: { data } }) => {
          commit(types.RECEIVED_QUESTIONS, { data });
          resolve(data);
        });
      });
    },
  },
  mutations: {
    [types.RECEIVED_QUESTIONS](state, { data }) {
      state.all = data;
    },
    [types.CLEARED_QUESTIONS](state) {
      state.all = [];
    },
  },
};
